import React, { useRef } from 'react'
import Popover from '@/components/Popover'
import PropTypes from 'prop-types';
import NotificationPage from '@/components/NotificationPage/index'
import { useNavigate } from '@/lib/router-dom/index';

const NotificationPopover = ({
	isActive,
	pivotNotification,
	notificationArr,
	onlyUnRead,
	getAllNotifications,
	markReadNotificationItem,
	markReadAllNotifications,
	showUnreadNotifications,
	initNotifications,
	handleRedirect,
	setIsActive,
	loading,
	handlePopup
}) => {
	const { goTo } = useNavigate()

	const childRef = useRef()

	function handleChildScroll(e) {
		if (childRef.current) {
			childRef.current.handleNotificationListScroll(e)
		}
	}

	return (
		<div className="profile-header__action" data-testid='notification-popup'>
			<div className="notification-popover-container">
				<Popover visible={isActive} placement="right-start" >
					<Popover.Content>
						{/* Notification wrapper */}
						<div className="notification-in-app-outer">
							<div className='notification-in-app' onScroll={handleChildScroll}>
								<NotificationPage
									ref={childRef}
									notificationType={'in-app'}
									pivotNotification={pivotNotification}
									notificationArr={notificationArr}
									onlyUnRead={onlyUnRead}
									getAllNotifications={getAllNotifications}
									markReadNotificationItem={markReadNotificationItem}
									markReadAllNotifications={markReadAllNotifications}
									showUnreadNotifications={showUnreadNotifications}
									initNotifications={initNotifications}
									handleRedirect={handleRedirect}
									setIsActive={setIsActive}
									loading={loading}
								/>
							</div>
						</div>

						<div
							className="notification-in-app--bottom"
							role="none"
							onClick={() => {
								goTo("/notification-page");
								handlePopup(isActive);
							}}
						>
							View All Notifications
						</div>
					</Popover.Content>
				</Popover>
			</div>
		</div>
	)
}

export default NotificationPopover


NotificationPopover.propTypes = {
	isActive: PropTypes.bool.isRequired,
	pivotNotification: PropTypes.string,
	notificationArr: PropTypes.arrayOf(PropTypes.object),
	onlyUnRead: PropTypes.bool,
	getAllNotifications: PropTypes.func.isRequired,
	markReadNotificationItem: PropTypes.func.isRequired,
	markReadAllNotifications: PropTypes.func.isRequired,
	showUnreadNotifications: PropTypes.func.isRequired,
	initNotifications: PropTypes.func.isRequired,
	handleRedirect: PropTypes.func.isRequired,
	setIsActive: PropTypes.func.isRequired,
	loading: PropTypes.bool.isRequired,
	handlePopup: PropTypes.func.isRequired
};
